/*eslint-disable */
// import QuestionBankModel from '../../Model/QuestionBank'
import request from '../../Utils/curl'
import Utility from "../../Utils/utility";

let QuizBanks = {
  /**
   * quizBankList
   */
  async quizBankList (context, quizBankObj) {
    Utility.showLoader = true;
    Utility.loadingMsg = "Please wait....";

    try{
      let post_data = new FormData();

      for (let key in quizBankObj) {
        if (quizBankObj[key]) {
          post_data.append(key, quizBankObj[key]);
        }
        else if (typeof quizBankObj[key] == 'number' && quizBankObj[key] == 0) {
          post_data.append(key, quizBankObj[key]);
        }
      }

      return await request.curl(context, "quiz_bank_list", post_data, process.env.VUE_APP_QUIZ_SERVICE)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at quizBankList() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * quizBankList
   */
  async quizBankListConsole (context, quizBankObj) {
    Utility.showLoader = true;
    Utility.loadingMsg = "Please wait....";

    try{
      let post_data = new FormData();

      for (let key in quizBankObj) {
        if (quizBankObj[key]) {
          if (typeof quizBankObj[key] == "object") {
            post_data.append(key, JSON.stringify(quizBankObj[key]));
          }
          else {
            post_data.append(key, quizBankObj[key]);
          }
        }
        else if (typeof quizBankObj[key] == 'number' && quizBankObj[key] == 0) {
          post_data.append(key, quizBankObj[key]);
        }
      }

      return await request.curl(context, "quiz_bank_list_console", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at quizBankList() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * quizBankUserResponse
   */
  async quizBankUserResponse (context, quizBankObj) {
    try{
      let post_data = new FormData();

      for (let key in quizBankObj) {
        if (quizBankObj[key]) {
          post_data.append(key, quizBankObj[key]);
        }
      }

      return await request.curl(context, "quiz_bank_user_response", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at quizBankUserResponse() and Exception:',err.message)
    }
  },

  /**
   * quizBankView
   */
  async quizBankView (context, quizBankId, aprsId = null, questionState = null) {
    try {
      let post_data = new FormData();
      post_data.append('qbk_id', quizBankId);
      if (aprsId) {
        post_data.append('aprs_id', aprsId);
      }

      if (questionState) {
        post_data.append('questionState', questionState);
      }
      
      return await request.curl(context, "quiz_bank_view", post_data)
      .then(async response => {
        return response;
      });
    }
    catch (err) {
      console.error("Exception occurred at quizBankView() and Exception:",err.message)
    }
  },

  /**
   * quizBankViewV1
   */
  async quizBankViewV1 (context, quizBankId, aprsId = null, questionState = null) {
    try {
      let post_data = new FormData();
      post_data.append('qbk_id', quizBankId);
      if (aprsId) {
        post_data.append('aprs_id', aprsId);
      }

      if (questionState) {
        post_data.append('questionState', questionState);
      }

      return await request.curl(context, "quiz_bank_view_v1", post_data)
      .then(async response => {
        return response;
      });
    }
    catch (err) {
      console.error("Exception occurred at quizBankViewV1() and Exception:",err.message)
    }
  },

  /**
   * quizBankAdd
   */
  async quizBankAdd (context, quizBankObj) {
    try{
      let post_data = new FormData();

      for (let key in quizBankObj) {
        key == ""
        if (key == "is_essay_type_numeric") {
          if (quizBankObj[key] == true) {
            post_data.append(key, 1);
          }
          else {
            post_data.append(key, 0);
          }
        }
        else if (quizBankObj[key] || typeof quizBankObj[key] == 'number') { // to avoid null as
          if (typeof quizBankObj[key] == "object") {
            post_data.append(key, JSON.stringify(quizBankObj[key]));
          }
          else {
            post_data.append(key, quizBankObj[key]);
          }
        }
      }

      return await request.curl(context, "quiz_bank_add", post_data)
      .then(async response => {
          return response;
      });
    }
    catch(err){
      console.error('Exception occurred at quizBankAdd() and Exception:',err.message)
    }
  },

  /**
   * quizBankEdit
   */
  async quizBankEdit (context, quizBankObj) {
    try{
      let post_data = new FormData();

      for (let key in quizBankObj) {
        if (key == "deleted") {
          post_data.append(key, quizBankObj[key])
        }
        else if (key == "is_essay_type_numeric") {
          if (quizBankObj[key] == true) {
            post_data.append(key, 1);
          }
          else {
            post_data.append(key, 0);
          }
        }
        else if (quizBankObj[key] && typeof quizBankObj[key] == "object") {
          post_data.append(key, JSON.stringify(quizBankObj[key]));
        }
        else if (quizBankObj[key] !== undefined && quizBankObj[key] !== null) {
          post_data.append(key, quizBankObj[key]);
        }
      }

      return await request.curl(context, "quiz_bank_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at quizBankEdit() and Exception:',err.message)
    }
  },

  /**
   * quizBankDelete
   */
  async quizBankDelete (context, quizBankObj) {
    try{
      let post_data = new FormData();

      for (let key in quizBankObj) {
        if (quizBankObj[key] && typeof quizBankObj[key] == "object") {
          post_data.append(key, JSON.stringify(quizBankObj[key]));
        }
        else if (quizBankObj[key] !== undefined && quizBankObj[key] !== null) {
          post_data.append(key, quizBankObj[key]);
        }
      }

      return await request.curl(context, "quiz_bank_delete", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at quizBankDelete() and Exception:',err.message)
    }
  },

  /**
   * quizBankBulkDelete
   */
  async quizBankBulkDelete (context, quizBankDeleteObj) {
    try{
      let post_data = new FormData();
      if (quizBankDeleteObj.app_id) {
        post_data.append('app_id', quizBankDeleteObj.app_id)
      }
      else if (quizBankDeleteObj.app_category) {
        post_data.append('app_category', quizBankDeleteObj.app_category)
      }
      post_data.append('soft_delete', quizBankDeleteObj.soft_delete)

      return await request.curl(context, "quiz_bank_bulk_delete", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at quizBankBulkDelete() and Exception:',err.message)
    }
  },

  /**
   * appsAutomaticResultGenerate
   */
  async appsAutomaticResultGenerate (context, attempQuizObj) {
    try{
      let post_data = new FormData();

      for (let key in attempQuizObj) {
        if (typeof attempQuizObj[key] == "object") {
          post_data.append(key, JSON.stringify(attempQuizObj[key]));
        }
        else {
          post_data.append(key, attempQuizObj[key]);
        }
      }

      return await request.curl(context, "apps_automatic_result_generate", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at appsAutomaticResultGenerate() and Exception:',err.message)
    }
  },

  /**
   * qbkCategory
   */
  async qbkCategory (context, quizBankObj = {}) {
    try {      
      let post_data = new FormData();
      for (let key in quizBankObj) {
        if (quizBankObj[key] !== undefined && quizBankObj[key] !== null) {
          post_data.append(key, quizBankObj[key]);
        }
      }
      return await request.curl(context, "quiz_bank_qbk_category", post_data)
      .then(async response => {
        return response;
      });
    }
    catch (err) {
      console.error("Exception occurred at qbkCategory() and Exception:",err.message)
    }
  },

  /**
   * imageDeleteFromQuizBank
   */
  async imageDeleteFromQuizBank (context, quizBankId) {
    try {
      Utility.showLoader = true;
      Utility.loadingMsg = "Uploading....";
      let post_data = new FormData();
      post_data.append("qbk_id", quizBankId);
      post_data.append("image", null);

      return await request.curl(context, "quiz_bank_image_remove", post_data)
      .then(async (response) => {
        Utility.showLoader = false;
        Utility.loadingMsg = "";
        return response;
      });
    }
    catch (err) {
      Utility.showLoader = false;
      Utility.loadingMsg = "";
      console.error("Exception occurred at imageDeleteFromQuizBank() and Exception:", err.message);
    }
  },

  /**
   * imageAddToQuizBank
   */
  async imageAddToQuizBank(context, imageObj) {
      try {
        Utility.showLoader = true;
        Utility.loadingMsg = "Uploading....";
        let post_data = new FormData();

        for (let key in imageObj) {
          if (key === "image") {
            if (Array.isArray(imageObj[key])) {
              //sending the image one by one because in this way it get send as file
              // if sending whole image array at once then it will get send as string of array ie '['apple', 'banana']'
              for (let index in imageObj["image"]) {
                let pic = imageObj["image"][index];
                post_data.append(pic.image_type, pic.image.img, pic.image.name);
              }
            }
            else {
              post_data.append(key, imageObj[key]);
            }
          }
          else if (key === "image_type") {
            post_data.append(key, JSON.stringify(imageObj[key]));
          }
          else {
            post_data.append(key, imageObj[key]);

          }
        }

        return await request.curl(context, "quiz_bank_image_add", post_data)
        .then(async (response) => {
          Utility.showLoader = false;
          Utility.loadingMsg = "";
          return response;
        });
      }
      catch (err) {
        Utility.showLoader = false;
        Utility.loadingMsg = "";
        console.error(
          "Exception occurred at imageAddToQuizBank() and Exception:",
          err.message
        );
      }
  },

  /**
   * quizBankSolve
   */
  async  quizBankSolve(context, solveObj) {
    try {
      Utility.showLoader = true;
      Utility.loadingMsg = "Solving....";
      let post_data = new FormData();

      for (let key in solveObj) {
        if (solveObj[key] || typeof solveObj[key] == 'number') { // to avoid null as
          if (typeof solveObj[key] == "object") {
            post_data.append(key, JSON.stringify(solveObj[key]));
          }
          else {
            post_data.append(key, solveObj[key]);
          }
        }
      }

      return await request.curl(context, "quiz_bank_gen_ans_explanation", post_data)
      .then(async (response) => {
        Utility.showLoader = false;
        Utility.loadingMsg = "";
        return response;
      });
    }
    catch (error) {
      console.error("Exception in quizBankSolve and error: ", error)
    }
  },

  /**
   * quizBankQuizQuestionAnalyse
   */
  async  quizBankQuizQuestionAnalyse(context, analyseObj) {
    try {
      Utility.showLoader = true;
      Utility.loadingMsg = "Analysing....";
      let post_data = new FormData();

      for (let key in analyseObj) {
        if (analyseObj[key] || typeof analyseObj[key] == 'number') { // to avoid null as
          if (typeof analyseObj[key] == "object") {
            post_data.append(key, JSON.stringify(analyseObj[key]));
          }
          else {
            post_data.append(key, analyseObj[key]);
          }
        }
      }

      return await request.curl(context, "quiz_bank_quiz_question_analyse", post_data)
      .then(async (response) => {
        Utility.showLoader = false;
        Utility.loadingMsg = "";
        return response;
      });
    }
    catch (error) {
      console.error("Exception in quizBankQuizQuestionAnalyse and error: ", error)
    }
    finally {
      Utility.showLoader = false;
    }
  },
  /**
   * quizBankAnalyzeAppQuizOptionsAndUpdateCorrectAnswers
   */
  async quizBankAnalyzeAppQuizOptionsAndUpdateCorrectAnswers(context, quizBankObj){
    try {
      Utility.showLoader = true;
      Utility.loadingMsg = "Analysing questions please Wait....";

      let post_data = new FormData();
      for (let key in quizBankObj) {
        if (quizBankObj[key] !== undefined && quizBankObj[key] !== null) {
          post_data.append(key, quizBankObj[key]);
        }
      }
      return await request.curl(context, "quiz_bank_analyze_app_quiz_options_and_update_correct_answers", post_data)
      .then(async response => {
        return response;
      });
    }
    catch (err) {
      console.error("Exception occurred at quizBankAnalyzeAppQuizOptionsAndUpdateCorrectAnswers() and Exception:",err.message)
    }
    finally {
      Utility.showLoader = false;
    }
  },

  /**
   * counsellingQuizBankList
   */
  async counsellingQuizBankList(context, payload) {
    try {
      Utility.showLoader = true;
      Utility.loadingMsg = "Counselling questions please Wait....";
      const post_data = new FormData();
      
      const dataFiled = ['app_id', 'gide_user_id', 'user_id', 'skill', 'qbk_category'];
      dataFiled.forEach(key => {
        if (payload?.[key]) {
          post_data.append(key, payload[key]);
        }
      });

      return await request.curl(context, "quiz_question_answer_list", post_data, process.env.VUE_APP_QUIZ_SERVICE);
    }
    catch (err) {
      console.error('Exception occurred at counsellingQuizBankList():', err.message);
      throw err; 
    }
    finally {
      Utility.showLoader = false;
    }
  },
  
  /**
   * quizFilterList
   */
  async quizBankFilterList (context, filterName = "", payload) {
    if (!filterName) {
      return
    }
    Utility.showLoader = true
    Utility.loadingMsg = "Please wait...."
    try {
      let post_data = new FormData()
      post_data.append("filter_name", filterName)

      if (payload && Object.keys(payload).length > 0) {
        for (let key in payload) {
          if (payload[key] !== undefined && payload[key] !== null) {
            post_data.append(key, payload[key])
          }
        }
      }

      return await request.curl(context, "quiz_bank_filter_list", post_data)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at quiz_bank_filter_list() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  }
}

export {
  QuizBanks
}
